import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { JsonDataService } from 'vhobjects-service/src/services';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import {
  NzContextMenuService,
  NzDropdownMenuComponent,
} from 'ng-zorro-antd/dropdown';
// import { EditNameComponent } from './edit-name/edit-name.component';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
// import { ChooseIconComponent } from '../../../../objects/basic/icon/choose-icon/choose-icon.component';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { ChooseIconComponent } from 'vhobjects-service';
import { EditNameComponent } from 'vhobjects-service';
import { FunctionService} from 'vhobjects-service/src/services';

@Component({
  selector: 'atw-frame-banner-config',
  templateUrl: './frame-banner-config.component.html',
  styleUrls: ['./frame-banner-config.component.scss'],
})

export class AtwFrameBannerConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() position: any; // xác định position là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  @Output() changeOptionConfig = new EventEmitter<any>();

  public isViewAll: boolean = false;
  public isCollapsed: boolean = false;
  public dataConfig: any;
  fonts = [];
  public slideTransitionAnimation = [
    {
      label: 'ro_dan',
      value: 'fade_in',
    },
    {
      label: 'truot_phai',
      value: 'slide_right',
    },
    {
      label: 'truot_trai',
      value: 'slide_left',
    },
    {
      label: 'truot_phai_trai',
      value: 'slide',
    },
    {
      label: 'phong_to_dan',
      value: 'zoom_in',
    },
    {
      label: 'xoay_phai',
      value: 'rotate',
    },
    {
      label: 'quay_vong_truc_x',
      value: 'flip_x',
    },
    {
      label: 'va_dap_nhe',
      value: 'bounce',
    },
    {
      label: 'mo_sang_ro_dan',
      value: 'blur',
    },
    {
      label: 'trang_den_sang_mau',
      value: 'grayscale',
    },
    {
      label: 'co_lai_theo_chieu_ngang',
      value: 'squeeze',
    },
    {
      label: 'co_lai_theo_chieu_doc',
      value: 'shutter',
    },
    {
      label: 'co_lai_va_xoay',
      value: 'scale_rotate',
    },
    {
      label: 'dau_cong',
      value: 'cube',
    },
    {
      label: 'di_chuyen_phai_sang_trai_mo_dan',
      value: 'fly_left_fade',
    },
    {
      label: 'di_chuyen_trai_sang_phai_mo_dan',
      value: 'fly_right_fade',
    },
    {
      label: 'di_chuyen_tu_tren_xuong_mo_dan',
      value: 'fly_top_fade',
    },
    {
      label: 'di_chuyen_tu_duoi_len_mo_dan',
      value: 'fly_bottom_fade',
    },
    {
      label: 'di_chuyen_tu_tren_xuong',
      value: 'fly_top',
    },
    {
      label: 'di_chuyen_tu_duoi_len',
      value: 'fly_bottom',
    },
    {
      label: 'mo_dan_va_thu_nho',
      value: 'fade_scale',
    },
    {
      label: 'ro_dan_va_phong_to',
      value: 'checkerboard',
    },
    {
      label: 'di_chuyen_theo_duong_cheo',
      value: 'diagonal_split',
    },
    {
      label: 'nho_dan_sang_trai',
      value: 'zoomout_zoomin',
    },
    {
      label: 'xoay_tron_sang_trai',
      value: 'zoomout_zoomin_circle',
    },
    {
      label: 'XYZ',
      value: 'xyz',
    },
    {
      label: 'nga_ve_truoc',
      value: 'fall_over',
    },
  ];
  public stylesField = [
    {
      title: 'dieu_chinh_vien_khung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien_nut_phan_trang',
      index: 2,
    },
    {
      title: 'cau_hinh_chi_tiet_nut_prev',
      index: 3,
    },
    {
      title: 'cau_hinh_chi_tiet_nut_next',
      index: 4,
    },
  ];
  positionMap = { 'bottom': 'duoi', 'top': 'tren', 'left': 'trai', 'right': 'phai' };
  public currentViewAll: any = {};
  public openMenu: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
    menu10: false,
  };
  public urlBackgroundImage = ''; // Giá trị đường dẫn của background-image
  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private jsonDataService: JsonDataService,
    private nzContextMenuService: NzContextMenuService,
    private matDialog: MatDialog,
    private http: HttpClient,
    private vhEventMediator: VhEventMediator,
    @Inject(PLATFORM_ID) private platformId: Object,
    private functionService: FunctionService,
  ) { 
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId))
      forkJoin([
        this.http.get('assets/fonts/fonts.json'),
      ]).subscribe(([fonts]: any) => {
        this.fonts = fonts;
      })
  }


  ngOnChanges(changes: SimpleChanges): void {
    this.config['frame-banner']['dots_position'] ??= "bottom";
    this.class['frame-banner__slick-dot']['position'] ??= "relative";
    this.class['frame-banner__slick-dot--active']['position'] ??= "relative";
    this.class["frame-banner__slick-dot__label"] ??= {
      "position": "absolute",
      "right": "0",
      "width": "80px",
      "height": "25px",
      "display": "flex",
      "jusitfy-content": "center",
      "align-items": "center",
      "transform": "translateX(0) scaleX(0)",
      "opacity": "0",
      "background-color": "red",
      "color": "#ffffff",
      "border-width": "1px",
      "border-style": "solid",
      "border-color": "#8e8e8e",
      "border-radius": "50%"
    };
    this.class["frame-banner__slick-dot__label--active"] ??= {
      "position": "absolute",
      "right": "0",
      "width": "80px",
      "height": "25px",
      "display": "flex",
      "jusitfy-content": "center",
      "align-items": "center",
      "transform": "translateX(0) scaleX(0)",
      "opacity": "0",
      "background-color": "red",
      "color": "#ffffff",
      "border-width": "1px",
      "border-style": "solid",
      "border-color": "#8e8e8e",
      "border-radius": "50%"
    };
    this.config['slick_dot_label'] ??= {};
    this.config['slick_dot_label']['active_mode'] ??= 'none'; // `always` loại cố định sẽ xuất hiện, `timed` loại sẽ xuất hiện sau đó thì biến mất, `none` loại không hiển thị
    this.config['slick_dot_label']['is_label_for_dot'] ??= false;
    this.config['slick_dot_label']['hover_label_translateX'] ??= '-32px';
    this.config['slick_dot_label']['hover_label_active_translateX'] ??= '-32px';
  }

  //Hàm update class
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {

      });
  }

  // //Hàm update config
  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => {

      });
  }

  // /**
  //  * Cập nhật staticdata vào database.
  //  */
  updateStaticData() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then(
        (bool) => {

        },
        (error) => {
          console.error(error);
        }
      );
  }



  /** Thực hiện ẩn hiện menu config
   *
   * @param value
   */
  openHandler(value: string): void {
    for (const key in this.openMenu) {
      if (key !== value) {
        this.openMenu[key] = false;
      }
    }
  }


  /**
   * Hàm này thực hiện them slide cho block, với giá trị slide cho trước. Chú ý: chỉ cần xử lí label
   */
  addSlide() {
    let maxIndex = 0;
    this.objectChoosing.objects.forEach((frame: any) => {
      if (frame.index > maxIndex) {
        maxIndex = frame.index;
      }
    })

    this.jsonDataService.getFrame('frame_blank').subscribe((frame: any) => {
      let dataframe = {
        ...frame,
        is_child_banner: true,
        id_object: this.objectChoosing._id,
        name: 'slide ' + (maxIndex + 2),
        index: maxIndex + 1,
        desktop_class: {
          ...frame.desktop_class,
          'frame-blank': {
            ...frame.desktop_class['frame-blank'],
            'background-color': "#fff",
            width: "100%",
            'min-height': '100%'
          }
        },
        mobile_portrait_class: {
          ...frame.mobile_portrait_class,
          'frame-blank': {
            ...frame.mobile_portrait_class['frame-blank'],
            'background-color': "#fff",
            width: "100%",
            'min-height': '100%'
          }
        },
        tablet_landscape_class: {
          ...frame.tablet_landscape_class,
          'frame-blank': {
            ...frame.tablet_landscape_class['frame-blank'],
            'background-color': "#fff",
            width: "100%",
            'min-height': '100%'
          }
        },
        tablet_portrait_class: {
          ...frame.tablet_portrait_class,
          'frame-blank': {
            ...frame.tablet_portrait_class['frame-blank'],
            'background-color': "#fff",
            width: "100%",
            'min-height': '100%'
          }
        },
        mobile_landscape_class: {
          ...frame.mobile_landscape_class,
          'frame-blank': {
            ...frame.mobile_landscape_class['frame-blank'],
            'background-color': "#fff",
            width: "100%",
            'min-height': '100%'
          }
        }
      };

      delete dataframe.desktop_position;
      delete dataframe.tablet_portrait_position;
      delete dataframe.tablet_landscape_position;
      delete dataframe.mobile_portrait_position;
      delete dataframe.mobile_landscape_position;

      this.vhQueryAutoWeb.addObject(dataframe).then(
        (frameResponse: any) => {

        },
        (error) => {
          console.log(error);
          alert('Đã xảy ra lỗi khi thêm khối');
        }
      );
    });
  }

  deleteItem(frame) {
    if (isPlatformBrowser(this.platformId))
      this.vhQueryAutoWeb.deleteObject(frame._id).then(
        (response: any) => {
          if (response) {
            const slideNumber = document.getElementById(this.objectChoosing._id).querySelector('.frame-banner__show-banner--number-text-content').textContent;
            const currentIndex = Number(slideNumber.split(' /')[0]) - 1;
            // Nếu xóa slide cuối cùng thì chuyển sang chọn slide kế cuối
            if (currentIndex === frame.index && frame.index >= this.objectChoosing.objects.length) {
              this.selectSlide(currentIndex - 1);
            }
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  /** Hàm thực hiện xử lý khi thay đổi vị trí của banner
   *
   * @param event
   */
  cdkDropListDropped(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.objectChoosing.objects, event.previousIndex, event.currentIndex);

    this.objectChoosing.objects.forEach((item, index) => {
      item.index = index;
      if(this.type== 'admin') {
        if(!item.fieldUpdate) item.fieldUpdate = []
        if(!item.fieldUpdate.includes('index')) item.fieldUpdate.push('index')
      } else  this.vhQueryAutoWeb.updateObject(item._id, { index: item.index })
    });

  }

  isShowContextMenu = false;
  onContextMenu(event: MouseEvent, menu: NzDropdownMenuComponent): void {
    this.isShowContextMenu = !this.isShowContextMenu;
    if (this.isShowContextMenu === true) {
      this.nzContextMenuService.create(event, menu);
    } else {
      this.nzContextMenuService.close();
    }
  }

  /** Hàm thay đổi thêm frame
   *
   * @param frame
   */
  editNameItem(frame) {
    this.matDialog
      .open(EditNameComponent, {
        width: '20%',
        data: frame.name,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          frame.name = result;
          const dataUpdate = {
            name: result,
          };

          this.vhQueryAutoWeb.updateObject(frame._id, dataUpdate);
        }
      });
  }

  /** Hàm thay đổi thêm frame
   *
   * @param frame
   */
  editLabelItem(frame) {
    const titles = {};
    this.functionService.multi_languages.forEach(lang => {
      frame['title_' + lang.code] ??= 'Tên slide';
      titles['title_' + lang.code] ??= frame['title_' + lang.code];
    });
    this.matDialog
      .open(EditNameComponent, {
        width: '20%',
        data: {
          ...titles,
          extraData: {
            placeholder: 'nhap_tieu_de_khung',
            titlePopup: 'cap_nhat_tieu_de_khung'
          },
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          const dataUpdate = {};
          this.functionService.multi_languages.forEach(lang => {
            dataUpdate['title_' + lang.code] ??= result[lang.code];
          });

          this.vhQueryAutoWeb.updateObject(frame._id, dataUpdate);
        }
      });
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /** Hàm thực hiện cập nhật chọn icon phải cho frame
   *
   */
  chooseIcon(position: 'prev' | 'next') {
    this.matDialog
      .open(ChooseIconComponent, {
        width: '80vw',
        height: '70vh',
        disableClose: false,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.config[`frame-banner__btn--${position}`]['icon_name'] =
            result.icon;

          this.updateConfig();
        }
      });
  }



  /**
   * Chọn slide ở phần config THÀNH PHẦN
   */
  selectSlide(index) {
    if (isPlatformBrowser(this.platformId)) {
      var banner = document.getElementById(this.objectChoosing._id);
      var frameSelected = banner?.querySelectorAll<HTMLElement>(".frame-banner__slick-dots>li")[index];
      frameSelected?.click();
    }
  }

  // PHẦN BUTTON NEXT/PREV

  /**
   * Hàm thực hiện xử lý kích thước cho icon trong nút next/prev
   * @param event
   * @param type nút next hay prev
   */
  handleSetIconFontSize(event, type: 'prev' | 'next') {
    let value = `${event}px`;
    this.class[`frame-banner__icon--${type}`]['font-size'] =
      this.class[`frame-banner__icon--${type}`]['height'] =
      this.class[`frame-banner__icon--${type}`]['width'] =
      value;
    this.updateClass();
  }

  /**
   * Set background cho nút next/prev
   * @param type nút next hay prev
   */
  handleSetButtonBackground(type) {
    if (this.config[`frame-banner__btn--${type}`]['background_check']) {
      this.class[`frame-banner__btn--${type}`]['background-color'] = '#ffffff';
    }
    else {
      this.class[`frame-banner__btn--${type}`]['background-color'] = 'transparent';
    }
    this.updateConfig();
    this.updateClass();
  }

  /**
   * Set border cho nút next/prev
   * @param type nút next hay prev
   */
  handleSetButtonBorder(type) {
    if (this.config[`frame-banner__btn--${type}`]['border_check']) {
      this.class[`frame-banner__btn--${type}`]['border-width'] = '2px';
    }
    else {
      this.class[`frame-banner__btn--${type}`]['border-width'] = '0px';
    }
    this.updateConfig();
    this.updateClass();
  }

  /**
   * Kiểu nền cho nút next/prev
   * @param event
   * @param type nút next hay prev
   */
  handleSetButtonStyle(event, type) {
    switch (event) {
      case 'circle':
        this.class[`frame-banner__btn--${type}`]['border-radius'] = '50%';
        this.class[`frame-banner__btn--${type}`]['height'] = this.class[`frame-banner__btn--${type}`]['width'];
        break;
      case 'square':
        this.class[`frame-banner__btn--${type}`]['border-radius'] = '0px';
        this.class[`frame-banner__btn--${type}`]['height'] = this.class[`frame-banner__btn--${type}`]['width'];
        break;
      case 'rectangle':
        this.class[`frame-banner__btn--${type}`]['border-radius'] = '0px';
        break;
    }

    this.updateConfig();
    this.updateClass();
  }

  /**
   * Toggle đổ bóng cho nút next/prev
   * @param type nút next hay prev
   */
  handleToggleButtonBoxShadow(type) {
    if (this.config[`frame-banner__btn--${type}`]['box-shadow']['box-shadow_check']) {
      this.handleSetButtonShadow(type);
    }
    else {
      this.class[`frame-banner__btn--${type}`]['box-shadow'] = '';
    }
    this.updateConfig();
    this.updateClass();
  }

  /**
   * Đổ bóng cho nút next/prev
   * @param type nút next hay prev
   */
  handleSetButtonShadow(type) {
    this.class[`frame-banner__btn--${type}`]['box-shadow'] = `${this.config[`frame-banner__btn--${type}`]['box-shadow']['offset_x']}px ${this.config[`frame-banner__btn--${type}`]['box-shadow']['offset_y']}px ${this.config[`frame-banner__btn--${type}`]['box-shadow']['blur_radius']}px ${this.config[`frame-banner__btn--${type}`]['box-shadow']['shadow_color']}`;
  }

  /**
   * Kích thước cho nút next/prev
   *  @param event
   *  @param type nút next hay prev
   */
  handleSetButtonSize(event, type) {
    var style = this.config[`frame-banner__btn--${type}`]['background_style'];

    this.class[`frame-banner__btn--${type}`]['width'] = event + 'px';

    switch (style) {
      case 'square':
      case 'circle':
        this.class[`frame-banner__btn--${type}`]['height'] = event + 'px';
        break;
    }
  }

  /**
   * Hàm cập nhật Vị trí nút phân trang
   *  @param event vị trí (flex-start/center/flex-end)
   */
  handleSetDotsAlign(event) {
    const isTopBottom = ['top', 'bottom'].includes(this.config['frame-banner']['dots_position']);

    if (isTopBottom) {
      this.class['frame-banner__slick-dots-wrapper']['justify-content'] = event;
      this.class['frame-banner__slick-dots-wrapper']['align-items'] = 'center';
    } else {}
      this.class['frame-banner__slick-dots-wrapper']['align-items'] = event;
      this.class['frame-banner__slick-dots-wrapper']['justify-content'] = 'center';

    switch (event) {
      case 'center':
        this.class['frame-banner__slick-dots-wrapper']['padding-left'] = '0px';
        this.class['frame-banner__slick-dots-wrapper']['padding-right'] = '0px';
        this.class['frame-banner__slick-dots-wrapper']['padding-top'] = '0px';
        this.class['frame-banner__slick-dots-wrapper']['padding-bottom'] = '0px';
        break;

      case 'flex-start':
        if (isTopBottom) {
          this.class['frame-banner__slick-dots-wrapper']['padding-right'] = '0px';
          this.class['frame-banner__slick-dots-wrapper']['padding-top'] = '0px';
          this.class['frame-banner__slick-dots-wrapper']['padding-bottom'] = '0px';
        } else {
          this.class['frame-banner__slick-dots-wrapper']['padding-bottom'] = '0px';
          this.class['frame-banner__slick-dots-wrapper']['padding-left'] = '0px';
          this.class['frame-banner__slick-dots-wrapper']['padding-right'] = '0px';
        }
        break;
      case 'flex-end':
        if (isTopBottom) {
          this.class['frame-banner__slick-dots-wrapper']['padding-left'] = '0px';
          this.class['frame-banner__slick-dots-wrapper']['padding-top'] = '0px';
          this.class['frame-banner__slick-dots-wrapper']['padding-bottom'] = '0px';
        } else {
          this.class['frame-banner__slick-dots-wrapper']['padding-top'] = '0px';
          this.class['frame-banner__slick-dots-wrapper']['padding-left'] = '0px';
          this.class['frame-banner__slick-dots-wrapper']['padding-right'] = '0px';
        }
        break;
    }

    this.updateConfig();
    this.updateClass();
  }

  /**
   * Hàm cập nhật Vị trí nút phân trang
   *  @param event vị trí (flex-start/center/flex-end)
   */
  handleSetDotsPosition(event) {
    switch (event) {
      case 'left':
        this.class['frame-banner__slick-dots-wrapper']['left'] = '15px';
        if (this.class['frame-banner__slick-dots-wrapper']['bottom']) delete this.class['frame-banner__slick-dots-wrapper']['bottom'];
        if (this.class['frame-banner__slick-dots-wrapper']['top']) delete this.class['frame-banner__slick-dots-wrapper']['top'];
        if (this.class['frame-banner__slick-dots-wrapper']['right']) delete this.class['frame-banner__slick-dots-wrapper']['right'];

        this.class['frame-banner__slick-dots-wrapper']['height'] = '100%';
        if (this.class['frame-banner__slick-dots-wrapper']['width']) delete this.class['frame-banner__slick-dots-wrapper']['width'];

        this.class['frame-banner__slick-dots']['flex-direction'] = 'column';
        break;
      case 'right':
        this.class['frame-banner__slick-dots-wrapper']['right'] = '15px';
        if (this.class['frame-banner__slick-dots-wrapper']['bottom']) delete this.class['frame-banner__slick-dots-wrapper']['bottom'];
        if (this.class['frame-banner__slick-dots-wrapper']['left']) delete this.class['frame-banner__slick-dots-wrapper']['left'];
        if (this.class['frame-banner__slick-dots-wrapper']['top']) delete this.class['frame-banner__slick-dots-wrapper']['top'];

        this.class['frame-banner__slick-dots-wrapper']['height'] = '100%';
        if (this.class['frame-banner__slick-dots-wrapper']['width']) delete this.class['frame-banner__slick-dots-wrapper']['width'];

        this.class['frame-banner__slick-dots']['flex-direction'] = 'column';
        break;
      case 'top':
        this.class['frame-banner__slick-dots-wrapper']['top'] = '15px';
        if (this.class['frame-banner__slick-dots-wrapper']['bottom']) delete this.class['frame-banner__slick-dots-wrapper']['bottom'];
        if (this.class['frame-banner__slick-dots-wrapper']['left']) delete this.class['frame-banner__slick-dots-wrapper']['left'];
        if (this.class['frame-banner__slick-dots-wrapper']['right']) delete this.class['frame-banner__slick-dots-wrapper']['right'];
        
        this.class['frame-banner__slick-dots-wrapper']['width'] = '100%';
        if (this.class['frame-banner__slick-dots-wrapper']['height']) delete this.class['frame-banner__slick-dots-wrapper']['height'];

        this.class['frame-banner__slick-dots']['flex-direction'] = 'row';
        break;
      case 'bottom':
        this.class['frame-banner__slick-dots-wrapper']['bottom'] = '15px';
        if (this.class['frame-banner__slick-dots-wrapper']['top']) delete this.class['frame-banner__slick-dots-wrapper']['top'];
        if (this.class['frame-banner__slick-dots-wrapper']['left']) delete this.class['frame-banner__slick-dots-wrapper']['left'];
        if (this.class['frame-banner__slick-dots-wrapper']['right']) delete this.class['frame-banner__slick-dots-wrapper']['right'];

        this.class['frame-banner__slick-dots-wrapper']['width'] = '100%';
        if (this.class['frame-banner__slick-dots-wrapper']['height']) delete this.class['frame-banner__slick-dots-wrapper']['height'];

        this.class['frame-banner__slick-dots']['flex-direction'] = 'row';
        break;
    }

    this.updateConfig();
    this.updateClass();
  }

  // PHẦN DOTS - Nút phân trang

  /**
   * Kiểu nút slide
   * @param event
   */
  handleSetDotsStyle(event) {
    switch (event) {
      case 'circle':
        this.class[`frame-banner__slick-dot`]['border-radius'] = '50%';
        this.class[`frame-banner__slick-dot`]['height'] = this.class[`frame-banner__slick-dot`]['width'];
        this.class[`frame-banner__slick-dot--active`]['border-radius'] = '50%';
        this.class[`frame-banner__slick-dot--active`]['height'] = this.class[`frame-banner__slick-dot--active`]['width'];
        break;
      case 'square':
        this.class[`frame-banner__slick-dot`]['border-radius'] = '0px';
        this.class[`frame-banner__slick-dot`]['height'] = this.class[`frame-banner__slick-dot`]['width'];
        this.class[`frame-banner__slick-dot--active`]['border-radius'] = '0px';
        this.class[`frame-banner__slick-dot--active`]['height'] = this.class[`frame-banner__slick-dot--active`]['width'];
        break;
      case 'rectangle':
        this.class[`frame-banner__slick-dot`]['border-radius'] = '0px';
        this.class[`frame-banner__slick-dot--active`]['border-radius'] = '0px';
        break;
    }

    this.updateConfig();
    this.updateClass();
  }

  /**
   * Kích thước nút phân trang
   * @param event
   * @param state nút active hay không
   */
  handleSetDotsSize(event, state) {
    if (state) state = '--' + state;
    var type = this.config['slick-dots']['background_style'];

    this.class[`frame-banner__slick-dot${state}`]['width'] = event + 'px';

    switch (type) {
      case 'square':
      case 'circle':
        this.class[`frame-banner__slick-dot${state}`]['height'] = event + 'px';
        break;
    }
  }

  /**
   * Hàm set vị trí Số slide
   */
  handleSetNumberTextContent(position) {
    switch (position) {
      case 'left':
        this.class['frame-banner__show-banner--number-text-content']['right'] = 'auto';
        this.class['frame-banner__show-banner--number-text-content']['left'] = '10px';
        this.class['frame-banner__show-banner--number-text-content']['transform'] = 'translateX(0)';
        break;
      case 'center':
        this.class['frame-banner__show-banner--number-text-content']['right'] = 'auto';
        this.class['frame-banner__show-banner--number-text-content']['left'] = '50%';
        this.class['frame-banner__show-banner--number-text-content']['transform'] = 'translateX(-50%)';
        break;
      case 'right':
        this.class['frame-banner__show-banner--number-text-content']['right'] = '10px';
        this.class['frame-banner__show-banner--number-text-content']['left'] = 'auto';
        this.class['frame-banner__show-banner--number-text-content']['transform'] = 'translateX(0)';
        break;
    }

    this.updateClass();
  }


  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['frame-banner']['width'] = event.width + 'px';
    if (event.height) this.class['frame-banner']['height'] = event.height + 'px';
    this.updateClass()
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
  }
}
